<template>
  
<div class="file-upload">
  <div class="img-list" v-if="previewImage.length > 0">

      <ul v-for="(item, idx) in previewImage" 
        :key="idx" 
        class="thumbnail"
        :style="{'background-image': 'url(' + item + ')'}"
      >
        <li @click="deleteImg(idx)" class="delImg">
          <img :src="require(`@/assets/image/delImg.svg`)" width="14px">
        </li>
      </ul>
  </div>
  <div v-if="previewImage.length < 10">
      <input ref="imageInput" type="file" accept="image/*" multiple hidden @change="onChangeImages">
      <div @click="onClickImageUpload" class="buttons" >
        
        <small>{{lang.add}}</small>
      </div>

      <small>{{lang.img_upload}}</small>

  

  </div>
</div>
    

  
</template>


<script>
export default {
  name: 'FileUpload',

  data () {
    return {
      previewImage: [],
      emitData: []
    }
  },
  props: ['lang'
  ],
  computed: {
  },
  methods: {
    onClickImageUpload() {
      this.$refs.imageInput.click();
    },
    async onChangeImages(e) {
      const files = Array.from(e.target.files);
      let preLength = this.previewImage.length
    this.$store.dispatch('setIsLoading', true);
      files.forEach(element => {
        this.getBase64(element).then(data => {
          if(this.previewImage.length < 10) {
            this.previewImage.push(data);
          }
        })
      })
      if (preLength + files.length > 10){
        alert(this.lang.photoMax)
      }
    },
    deleteImg (idx) {
      this.previewImage.splice(idx, 1) 
      this.emitData.splice(idx, 1) 
    },
    getBase64(file) {
      //Promise 실행순서
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          let image = new Image();
          image.src = e.target.result;
          image.onload = imageEvent => {
            resolve(this.resize_image(image, file));
          };
        };
        reader.onerror = error => reject(error);
      });
    },
    resize_image(img, file) {
      var canvas = document.createElement('canvas');
      var max_size = 1000;
      var width = img.width;
      var height = img.height;
      if (width > height){
        if(width > max_size){
          height *= max_size / width;
          width = max_size;
        }
      } else {
        if(height > max_size){
          width *= max_size / height;
          height = max_size;
        }
      }
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height)
      let dataUrl = canvas.toDataURL(file.type)

      if(this.previewImage.length < 10){
        let blobData = this.urltoFile(dataUrl, file)
        const payload = {
          id: 'istay',
          siteid: this.$store.state.siteid,
          file: file.name,
          data: blobData
        }
        this.$store.dispatch('setImage', payload).then(res => {
          if(res && res.result) this.emitData.push(res.result.fileName)
        })
      }
      return dataUrl
    },
    urltoFile(image, fileData) {
      const byteString = atob(image.split(',')[1])
      const ab = new ArrayBuffer(byteString.length)
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      const newBlob = new Blob([ab], {
        type: fileData.type,
      })
      return newBlob
    },
  },
  watch: {
    emitData: function () {
      this.$emit('emitData', { data: this.emitData })
    }
  }
}
</script>


<style lang="scss" scoped>
.img-list{
    height: 64px;
    white-space: nowrap;
    overflow-x: auto;

  
  
}

  .buttons{
    border: 1px solid $color-sub-point;
    display: inline-block;
    padding: 6px;
    border-radius: 16px;
    @include img('camera.svg');
    @include bg(16px, 8px, center);
    margin-right: 16px;

    small{
      color: $color-sub-point;
      margin-left: 20px;
    }
  }

  .thumbnail {
    margin: 6px 10px 0 0;
    position: relative;
    vertical-align: top;
    display: inline-block;
    border: 1px solid #E1E1E1;
    width: 50px;
    height: 50px;
    background-size:cover;
    background-position: center;
    object-fit: cover;
  }

  .delImg{
    position: absolute;
    overflow:visible;
    right: -7px;
    top: -7px;
  }
</style>
